/*
  koko-inspirado.js — personaliza el recuadro "Inspirado en ti" de la portada.

  El Liquid ya pintó las fichas de la colección "novedades" en el servidor,
  así que aquí no hay esqueleto ni parpadeo: si el visitante tiene historial,
  cambiamos esas fichas por recomendaciones suyas; si no, no tocamos nada.

  Regla de oro: cualquier fallo (red, JSON raro, localStorage bloqueado,
  cero resultados, corte por tiempo) deja intacto lo que pintó el servidor.

  Contrato del DOM (lo garantiza sections/kokorocao-bloques.liquid):
    [data-koko-inspirado]              → rejilla a personalizar
    [data-koko-bloque="mas-vendido"]   → rejilla de b4, sus productos se excluyen

  Contrato de datos (lo escribe assets/kokorocao-search-tracker.js):
    koko_searches → array de términos, máx 5, más reciente primero
    koko_viewed   → array de IDs de producto, máx 5, más reciente primero
*/
(function () {
  'use strict';

  var MAX_FICHAS = 6;
  var LIMITE_MS = 2500;   // corte duro para peticiones + imágenes: pasado esto no hay sustitución
  var FUNDIDO_MS = 160;
  var ANCHO_IMG = 260;    // el Liquid usa image_url: width: 260 para un render de 130px

  var LS_BUSQUEDAS = 'koko_searches';
  var LS_VISTOS = 'koko_viewed';

  var SEL_REJILLA = '[data-koko-inspirado]';
  var SEL_MAS_VENDIDO = '[data-koko-bloque="mas-vendido"]';
  var SEL_FICHA = 'a.koko-bloque__item';

  /* ── Utilidades ─────────────────────────────────────────── */

  // localStorage puede reventar en incógnito o con almacenamiento restringido.
  function leerLista(clave) {
    try {
      var crudo = window.localStorage.getItem(clave);
      if (!crudo) return [];
      var lista = JSON.parse(crudo);
      return Object.prototype.toString.call(lista) === '[object Array]' ? lista : [];
    } catch (e) {
      return [];
    }
  }

  function motionReducida() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  // Identificamos productos por su handle: es lo único común entre lo que
  // devuelve la API y los href que ya están pintados en el DOM de b4.
  function handleDe(url) {
    if (!url) return '';
    var limpia = String(url).split('#')[0].split('?')[0];
    var coincide = limpia.match(/\/products\/([^\/]+)/);
    return coincide ? coincide[1].toLowerCase() : limpia.toLowerCase();
  }

  // Los dos endpoints devuelven el precio en formatos distintos (centavos como
  // número, centavos como texto, o texto con moneda). Nos quedamos solo con los
  // dígitos: el porcentaje de descuento es un cociente, así que la escala da
  // igual mientras precio y comparado vengan en el mismo formato, y siempre lo
  // hacen porque salen de la misma respuesta.
  function aCentavos(valor) {
    if (typeof valor === 'number') return isFinite(valor) ? Math.round(valor) : 0;
    if (typeof valor === 'string') {
      var digitos = valor.replace(/[^0-9]/g, '');
      if (!digitos) return 0;
      var numero = parseInt(digitos, 10);
      return isFinite(numero) ? numero : 0;
    }
    return 0;
  }

  // suggest.json trae featured_image como objeto {url}; recommendations.json lo
  // trae como cadena y además ofrece images[]. Cubrimos las dos formas.
  function imagenDe(producto) {
    var destacada = producto.featured_image;
    if (destacada) {
      if (typeof destacada === 'string') return destacada;
      if (destacada.url || destacada.src) return destacada.url || destacada.src;
    }
    if (typeof producto.image === 'string') return producto.image;
    if (producto.image && (producto.image.src || producto.image.url)) {
      return producto.image.src || producto.image.url;
    }
    var imagenes = producto.images;
    if (imagenes && imagenes.length) {
      var primera = imagenes[0];
      if (typeof primera === 'string') return primera;
      if (primera && (primera.src || primera.url)) return primera.src || primera.url;
    }
    return null;
  }

  // Deja la URL del CDN pidiendo el mismo ancho que pide el Liquid. Quitamos el
  // sufijo heredado (_1024x1024) y los parámetros de tamaño previos para que no
  // compitan con el width que añadimos.
  function imagenCdn(bruta) {
    if (!bruta || typeof bruta !== 'string') return null;
    var url = bruta.trim();
    if (!url) return null;
    if (!/^(?:https?:)?\/\//.test(url) && url.charAt(0) !== '/') return null;

    var partes = url.split('?');
    var base = partes[0].replace(/_(?:\d+x\d*|x\d+)(?:_crop_[a-z]+)?(?:@[0-9]+x)?(?=\.[a-zA-Z0-9]+$)/, '');
    var conservados = [];

    if (partes.length > 1) {
      partes.slice(1).join('?').split('&').forEach(function (par) {
        if (!par) return;
        var clave = par.split('=')[0].toLowerCase();
        if (clave === 'width' || clave === 'height' || clave === 'crop') return;
        conservados.push(par);
      });
    }
    conservados.push('width=' + ANCHO_IMG);
    return base + '?' + conservados.join('&');
  }

  // Solo rutas relativas o http(s). Corta cualquier javascript: o data: que
  // pudiera colarse en una respuesta manipulada.
  function urlProducto(producto) {
    var url = typeof producto.url === 'string' ? producto.url : '';
    if (!url && producto.handle) url = '/products/' + producto.handle;
    url = String(url).trim();
    if (!url) return '';
    if (url.charAt(0) === '/') return url;
    if (/^https?:\/\//i.test(url)) return url;
    return '';
  }

  /* ── Normalización ──────────────────────────────────────── */

  // Devuelve la ficha lista para pintar, o null si el producto no sirve
  // (agotado, sin imagen, sin URL usable).
  function normalizar(producto) {
    if (!producto || typeof producto !== 'object') return null;
    if (producto.available === false) return null;

    var url = urlProducto(producto);
    if (!url) return null;

    var imagen = imagenCdn(imagenDe(producto));
    if (!imagen) return null;

    var titulo = typeof producto.title === 'string' ? producto.title : '';
    var precio = aCentavos(producto.price);
    var comparado = aCentavos(producto.compare_at_price);
    var descuento = 0;
    if (comparado > 0 && comparado > precio) {
      descuento = Math.round((comparado - precio) * 100 / comparado);
    }

    return {
      id: producto.id != null ? String(producto.id) : '',
      handle: handleDe(url),
      url: url,
      titulo: titulo,
      imagen: imagen,
      descuento: descuento
    };
  }

  function normalizarTodos(lista) {
    var fichas = [];
    if (!lista || !lista.length) return fichas;
    for (var i = 0; i < lista.length; i++) {
      var ficha = normalizar(lista[i]);
      if (ficha) fichas.push(ficha);
    }
    return fichas;
  }

  /* ── Peticiones ─────────────────────────────────────────── */

  // Nunca rechaza: cualquier fallo (incluido el abort del corte) se traduce en
  // lista vacía, así una fuente caída no arrastra a la otra.
  function pedirJson(url, senal) {
    var opciones = { headers: { Accept: 'application/json' } };
    if (senal) opciones.signal = senal;
    return window.fetch(url, opciones).then(function (respuesta) {
      if (!respuesta || !respuesta.ok) return null;
      return respuesta.json();
    }).catch(function () {
      return null;
    });
  }

  function pedirRecomendados(idProducto, senal) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(idProducto) +
      '&limit=' + MAX_FICHAS;
    return pedirJson(url, senal).then(function (datos) {
      if (!datos) return [];
      return normalizarTodos(datos.products);
    });
  }

  function pedirSugerencias(termino, senal) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(termino) +
      '&resources[type]=product&resources[limit]=' + MAX_FICHAS;
    return pedirJson(url, senal).then(function (datos) {
      if (!datos) return [];
      var recursos = datos.resources && datos.resources.results;
      return normalizarTodos(recursos && recursos.products);
    });
  }

  /* ── Fusión ─────────────────────────────────────────────── */

  // Handles que ya se ven en "Lo más vendido"; se leen del DOM para no
  // compartir estado entre secciones.
  function handlesMasVendido() {
    var excluidos = Object.create(null);
    var rejilla = document.querySelector(SEL_MAS_VENDIDO);
    if (!rejilla) return excluidos;
    var enlaces = rejilla.querySelectorAll('a[href]');
    for (var i = 0; i < enlaces.length; i++) {
      var handle = handleDe(enlaces[i].getAttribute('href') || enlaces[i].href);
      if (handle) excluidos[handle] = true;
    }
    return excluidos;
  }

  // Alterna entre las dos fuentes para que ninguna monopolice la rejilla, igual
  // que hace el motor de recomendaciones de la página de producto.
  function fusionar(listas, excluidos) {
    var elegidos = [];
    var handlesUsados = Object.create(null);
    var idsUsados = Object.create(null);

    function admitir(ficha) {
      if (!ficha || elegidos.length >= MAX_FICHAS) return;
      if (!ficha.handle || handlesUsados[ficha.handle]) return;
      if (ficha.id && idsUsados[ficha.id]) return;
      if (excluidos[ficha.handle]) return;
      if (ficha.id) idsUsados[ficha.id] = true;
      handlesUsados[ficha.handle] = true;
      elegidos.push(ficha);
    }

    var vueltas = 0;
    for (var i = 0; i < listas.length; i++) {
      if (listas[i].length > vueltas) vueltas = listas[i].length;
    }
    for (var v = 0; v < vueltas && elegidos.length < MAX_FICHAS; v++) {
      for (var j = 0; j < listas.length; j++) admitir(listas[j][v]);
    }

    return { fichas: elegidos, handles: handlesUsados };
  }

  /* ── Pintado ────────────────────────────────────────────── */

  // Construimos con createElement y asignación de propiedades: el texto que
  // viene de la API nunca se interpreta como HTML.
  // Descarga las imágenes en memoria antes de que las fichas entren al DOM.
  // Nunca rechaza: una imagen rota resuelve igual y su ficha entrará sin ella,
  // que es preferible a abandonar la sustitución entera.
  function precargarImagenes(urls) {
    var pendientes = [];
    for (var i = 0; i < urls.length; i++) {
      pendientes.push(precargarUna(urls[i]));
    }
    return window.Promise.all(pendientes);
  }

  function precargarUna(url) {
    return new window.Promise(function (resolver) {
      if (!url) return resolver();
      var img = new window.Image();
      img.onload = function () { resolver(); };
      img.onerror = function () { resolver(); };
      img.src = url;
      // Ya estaba en caché: algunos navegadores no disparan onload entonces.
      if (img.complete) resolver();
    });
  }

  function construirFicha(ficha) {
    var enlace = document.createElement('a');
    enlace.href = ficha.url;
    enlace.className = 'koko-bloque__item';
    enlace.title = ficha.titulo;

    if (ficha.descuento > 0) {
      var insignia = document.createElement('span');
      insignia.className = 'koko-bloque__badge';
      insignia.textContent = '-' + ficha.descuento + '%';
      enlace.appendChild(insignia);
    }

    // setAttribute y no la propiedad: `loading` no está reflejada en
    // navegadores antiguos y ahí la ficha saldría sin el atributo.
    // Aquí va 'eager' y no 'lazy' como en el Liquid, a propósito: estas fichas
    // sustituyen contenido que el visitante ya tiene delante, así que diferir
    // su carga solo consigue que las vea aparecer de una en una.
    var imagen = document.createElement('img');
    imagen.src = ficha.imagen;
    imagen.alt = ficha.titulo;
    imagen.setAttribute('width', '130');
    imagen.setAttribute('height', '130');
    imagen.setAttribute('loading', 'eager');
    imagen.className = 'koko-bloque__img';
    enlace.appendChild(imagen);

    return enlace;
  }

  function reemplazar(rejilla, fragmento) {
    if (typeof rejilla.replaceChildren === 'function') {
      rejilla.replaceChildren(fragmento);
      return;
    }
    while (rejilla.firstChild) rejilla.removeChild(rejilla.firstChild);
    rejilla.appendChild(fragmento);
  }

  // Fundido corto: se apaga, se cambia el contenido, se vuelve a encender.
  // Con prefers-reduced-motion el cambio es seco.
  function intercambiar(rejilla, fragmento) {
    if (motionReducida()) {
      reemplazar(rejilla, fragmento);
      return;
    }

    var transicionPrevia = rejilla.style.transition;

    function limpiar() {
      try {
        rejilla.style.transition = transicionPrevia || '';
        rejilla.style.removeProperty('opacity');
      } catch (e) {}
    }

    rejilla.style.transition = 'opacity ' + FUNDIDO_MS + 'ms ease';
    rejilla.style.opacity = '0';

    window.setTimeout(function () {
      try {
        reemplazar(rejilla, fragmento);
        rejilla.style.opacity = '1';
        window.setTimeout(limpiar, FUNDIDO_MS + 60);
      } catch (e) {
        // Si algo falla a media transición, al menos que la tarjeta se vea.
        limpiar();
      }
    }, FUNDIDO_MS);
  }

  /* ── Orquestación ───────────────────────────────────────── */

  function arrancar() {
    var rejilla = document.querySelector(SEL_REJILLA);
    if (!rejilla) return;
    if (typeof window.fetch !== 'function' || typeof window.Promise !== 'function') return;

    var busquedas = leerLista(LS_BUSQUEDAS);
    var vistos = leerLista(LS_VISTOS);
    var ultimaBusqueda = '';
    var ultimoVisto = '';

    for (var i = 0; i < busquedas.length && !ultimaBusqueda; i++) {
      if (typeof busquedas[i] === 'string' && busquedas[i].trim()) {
        ultimaBusqueda = busquedas[i].trim();
      }
    }
    for (var j = 0; j < vistos.length && !ultimoVisto; j++) {
      if (/^\d+$/.test(String(vistos[j]))) ultimoVisto = String(vistos[j]);
    }

    // Sin historial no hay nada que personalizar: lo del servidor ya está bien.
    if (!ultimaBusqueda && !ultimoVisto) return;

    // Referencias a las fichas de Novedades, por si hay que rellenar. Se clonan
    // al usarlas, así el DOM en vivo no se toca hasta el intercambio final.
    var originales = [];
    var fichasServidor = rejilla.querySelectorAll(SEL_FICHA);
    for (var k = 0; k < fichasServidor.length; k++) originales.push(fichasServidor[k]);

    var agotado = false;
    var controlador = null;
    var senal = null;
    if (typeof window.AbortController === 'function') {
      controlador = new window.AbortController();
      senal = controlador.signal;
    }

    // Corte a 2 s: aborta las peticiones y, si el navegador no soporta
    // AbortController, la bandera evita igualmente la sustitución tardía.
    var corte = window.setTimeout(function () {
      agotado = true;
      if (controlador) {
        try { controlador.abort(); } catch (e) {}
      }
    }, LIMITE_MS);

    var peticiones = [
      ultimaBusqueda ? pedirSugerencias(ultimaBusqueda, senal) : window.Promise.resolve([]),
      ultimoVisto ? pedirRecomendados(ultimoVisto, senal) : window.Promise.resolve([])
    ];

    window.Promise.all(peticiones).then(function (resultados) {
      if (agotado) return null;

      var fusion = fusionar([resultados[0], resultados[1]], handlesMasVendido());
      if (!fusion.fichas.length) {
        window.clearTimeout(corte);
        return null;
      }

      var fragmento = document.createDocumentFragment();
      var total = 0;
      var imagenes = [];
      for (var i = 0; i < fusion.fichas.length; i++) {
        fragmento.appendChild(construirFicha(fusion.fichas[i]));
        imagenes.push(fusion.fichas[i].imagen);
        total++;
      }

      // Faltan para llegar a 6: se completan con las de Novedades que no repitan.
      for (var j = 0; j < originales.length && total < MAX_FICHAS; j++) {
        var handle = handleDe(originales[j].getAttribute('href') || originales[j].href);
        if (handle && fusion.handles[handle]) continue;
        if (handle) fusion.handles[handle] = true;
        fragmento.appendChild(originales[j].cloneNode(true));
        total++;
      }

      // Esperar a tener las imágenes descargadas antes de tocar el DOM: si se
      // sustituye antes, las fichas entran sin imagen y el visitante las ve
      // aparecer de una en una durante un par de segundos.
      return precargarImagenes(imagenes).then(function () {
        window.clearTimeout(corte);
        if (agotado) return;
        intercambiar(rejilla, fragmento);
      });
    }).catch(function () {
      window.clearTimeout(corte);
      // Silencio deliberado: la rejilla del servidor se queda como está.
    });
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        try { arrancar(); } catch (e) {}
      });
    } else {
      arrancar();
    }
  } catch (e) {}
})();
